import React from 'react'

const NotFound = () => (
  <div>
    <h2>Store Not found</h2>
  </div>
)

export default NotFound
